export enum EnumArquivoRegistro {
    Boleto,
    Remessa,
    Historico,
    Transferencias
}